import acquisti from "./components/acquisti/_menu";
import anagrafiche from "./components/anagrafiche/_menu";
import attrezzature from "./components/attrezzature/_menu";
import avanzamenti from "./components/avanzamenti/_menu";
import consoleMenu from "./components/console/_menu";
import dashboard from "./components/dashboard/_menu";
import files from "./components/files/_menu";
import fornitore from "./components/fornitore/_menu";
import hr from "./components/hr/_menu";
import laser from "./components/laser/_menu";
import tubeLaser from "./components/laser/tube-laser/_menu";
import magazzino from "./components/magazzino/_menu";
import milkrun from "./components/milkrun/_menu";
import ordini from "./components/ordini/_menu";
import pianificazione from "./components/pianificazione/_menu";
import qualita from "./components/qualita/_menu";
import segnalazioni from "./components/segnalazioni/_menu";
import spooler from "./components/spooler/_menu";
import staff from "./components/staff/_menu";
import controlloGestione from "./components/controllo-gestione/_menu";
import teamLeader from "./components/team-leader/_menu";
import tempi from "./components/tempi/_menu";

export const workMenu = {
    anagrafiche,
    ordini,
    avanzamenti,
    pianificazione,
    milkrun,
    magazzino,
    attrezzature,
    tempi,
    laser,
    tube_laser: tubeLaser,
    staff,
    controllo_gestione: controlloGestione,
    team_leader: teamLeader,
    console: consoleMenu,
    acquisti,
    qualita,
    segnalazioni,
    dashboard,
    fornitore,
    hr,
    files,
    spooler,
};
